import React, { useMemo } from "react";

export default function AnalyticsFilterPanel({ routes = [], filters, setFilters }) {
  // === Собираем уникальные значения из всех маршрутов ===
  const drivers = useMemo(
    () => Array.from(new Set(routes.map((r) => r.driver).filter(Boolean))),
    [routes]
  );
  const loaders = useMemo(
    () => Array.from(new Set(routes.flatMap((r) => [r.loader1, r.loader2]).filter(Boolean))),
    [routes]
  );
  const routeNumbers = useMemo(
    () => routes.map((r) => r.route_number).filter(Boolean),
    [routes]
  );
  const districts = useMemo(
    () =>
      Array.from(
        new Set(
          routes.flatMap((r) =>
            (r.route_districts || "")
              .split(",")
              .map((d) => d.trim())
              .filter(Boolean)
          )
        )
      ),
    [routes]
  );

  const statuses = ["Открыта", "Закрыта", "Не доставлено"];
  const paymentTypes = [
    "Наличные",
    "Безнал",
    "Перевод",
    "Кредит",
    "Взаимозачет",
    "ПоСчету",
    "БезОплаты",
  ];

  // === универсальный обработчик ===
  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value || null,
    }));
  };

  const selectStyle = {
    padding: "6px 8px",
    borderRadius: 6,
    border: "1px solid #ccc",
    background: "#fff",
    fontSize: 13,
    minWidth: 150,
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        padding: "10px 14px",
        background: "#fff",
        borderRadius: 10,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        marginBottom: 20,
        alignItems: "center",
      }}
    >
      <span style={{ fontWeight: 600, color: "#333", marginRight: 4 }}>Фильтр:</span>

      <select
        style={selectStyle}
        value={filters.routeNumber || ""}
        onChange={(e) => updateFilter("routeNumber", e.target.value)}
      >
        <option value="">Все маршруты</option>
        {routeNumbers.map((n) => (
          <option key={n} value={n}>
            Маршрут №{n}
          </option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.driver || ""}
        onChange={(e) => updateFilter("driver", e.target.value)}
      >
        <option value="">Все водители</option>
        {drivers.map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.loader || ""}
        onChange={(e) => updateFilter("loader", e.target.value)}
      >
        <option value="">Все грузчики</option>
        {loaders.map((l) => (
          <option key={l} value={l}>
            {l}
          </option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.district || ""}
        onChange={(e) => updateFilter("district", e.target.value)}
      >
        <option value="">Все районы</option>
        {districts.map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.status || ""}
        onChange={(e) => updateFilter("status", e.target.value)}
      >
        <option value="">Все статусы</option>
        {statuses.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>

      <select
        style={selectStyle}
        value={filters.paymentType || ""}
        onChange={(e) => updateFilter("paymentType", e.target.value)}
      >
        <option value="">Все типы оплат</option>
        {paymentTypes.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
      </select>

      <button
        onClick={() =>
          setFilters({
            routeNumber: null,
            driver: null,
            loader: null,
            district: null,
            status: null,
            paymentType: null,
          })
        }
        style={{
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "6px 12px",
          cursor: "pointer",
          fontSize: 13,
          fontWeight: 500,
        }}
      >
        Сбросить
      </button>
    </div>
  );
}
